import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// import {
//   CommonModule,
//   LocationStrategy,
//   PathLocationStrategy,
// } from '@angular/common';
// pages
import { TopComponent } from './pages/top/top.component';
// import { CouponDetailComponent } from './pages/coupon-detail/coupon-detail.component';
import { environment } from 'src/environments/environment';

const routesForm: Routes = [
  {
    path: 'top',
    component: TopComponent,
  },
  {
    path: '**',
    redirectTo: '/top',
  },
];

// フォールバック: appname が未定義・その他の場合も設定アプリ（terminal-settings）を表示
// これにより JWT 認証エラー時も top ではなく terminal-settings に留まれる
const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./pages/akatsuki-denki/akatsuki-denki.module').then(
        (m) => m.AkatsukiDenkiModule
      ),
  },
  {
    path: '**',
    redirectTo: '/',
  },
];

const routesMobaproCoupon: Routes = [
  {
    path: 'top',
    component: TopComponent,
  },
  {
    path: '**',
    redirectTo: '/top',
  },
];

const routesAkatsuki: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./pages/akatsuki-denki/akatsuki-denki.module').then(
        (m) => m.AkatsukiDenkiModule
      ),
  },
  {
    path: '**',
    redirectTo: '/',
  },
];

@NgModule({
  imports: [
    // CommonModule,
    RouterModule.forRoot(
      environment.base.appname === 'gaabooForm'
        ? routesForm
        : environment.base.appname === 'mobaprocoupon' ||
          environment.base.appname === 'preview'
        ? routesMobaproCoupon
        : environment.base.appname === 'akatsuki'
        ? routesAkatsuki
        : routes,
      { useHash: true }
    ),
    TopComponent,
  ],
  exports: [RouterModule],
  providers: [
    // {
    //   provide: LocationStrategy,
    //   useClass: PathLocationStrategy
    // },
  ],
})
export class AppRoutingModule {}
